module.exports = __webpack_public_path__ + "img/CZ25783301.b059c33c.svg";